/**
 * Public Q&A Google can crawl on /bakery-in-barrie.
 * Keep in sync with backend/lib/bakeryFaqs.js.
 * Only facts from the live shop, menu, or site — do not invent services.
 */

export const BAKERY_LOCAL_FAQS: { question: string; answer: string }[] = [
  {
    question: "Where is Nanny B's Bakery in Barrie?",
    answer:
      "We are at 62 Commerce Park Drive, Unit L, Barrie, ON L4N 8W8 — south Barrie, same street as Galaxy Cinemas Barrie (72 Commerce Park Drive).",
  },
  {
    question: 'What are the bakery hours in Barrie?',
    answer:
      'Tuesday to Friday 11:00am–4:30pm, Saturday 10:00am–3:00pm. Closed Sunday and Monday. Holiday closures are posted on the website and Google listing.',
  },
  {
    question: 'Do you take custom cake orders in Barrie?',
    answer:
      'Yes. The menu asks for 72 hour notice on any cake order. Use the cake request form at nannybbakery.ca/cake-request, or call (705) 503-4966.',
  },
  {
    question: 'Can I order bakery treats online for pickup in Barrie?',
    answer:
      'Yes. Order on nannybbakery.ca for in-store pickup at Commerce Park. Website checkout is pickup only.',
  },
  {
    question: 'Do you deliver bakery orders in Barrie?',
    answer:
      'Delivery is through Uber Eats (green Order on Uber Eats buttons on the site). Website orders are pickup at the bakery.',
  },
  {
    question: 'How far ahead should I order a birthday cake?',
    answer:
      'Give us 72 hour notice, same as other custom cakes. Call (705) 503-4966 if you need to ask about a sooner date.',
  },
  {
    question: 'Do you make wedding cakes in Barrie?',
    answer:
      'Yes. Wedding is one of the occasions we take on custom cakes. The menu asks for 72 hour notice. Call (705) 503-4966 to plan the date and design.',
  },
  {
    question: 'Do you have gluten-free bakery items?',
    answer:
      'The menu has a gluten-free filter for items Tammy has marked. Tell us about allergies when you order — custom cake orders have a notes field for that.',
  },
  {
    question: 'Can I visit the bakery without a pre-order?',
    answer:
      'Yes. You can come in during open hours. The menu includes cookies, stuffed cookies, cheesecakes, tarts, bars, pastries, and sandwiches. Custom cakes still need 72 hour notice.',
  },
  {
    question: 'How do I pay for a website order?',
    answer:
      'Website orders are paid at checkout, then picked up at the bakery. For other payment questions, call (705) 503-4966.',
  },
  {
    question: 'Do you make stuffed cookies?',
    answer:
      'Yes. Stuffed cookies are on the menu (single, half dozen, and dozen). You pick flavours when you add them to the cart — Biscoff, Oreo, Nutella, and others Tammy has turned on.',
  },
  {
    question: 'How do I send a photo of a cake I want?',
    answer:
      'Use the cake request form at nannybbakery.ca/cake-request — you can add an optional photo. Or call (705) 503-4966 or email nannybbakedgoods@outlook.com.',
  },
  {
    question: 'Do you offer cake decorating classes?',
    answer:
      'Tammy hosts classes and events when they are on the schedule. Check the Events page — if none are listed, use the Contact page to request a class.',
  },
];

/** JSON-LD FAQPage fields (must match the visible questions on the page). */
export function buildFaqSchemaData() {
  return {
    mainEntity: BAKERY_LOCAL_FAQS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };
}
